import React from 'react';
import { Box, Tooltip } from '@mui/material';

/**
 * Small "Supporter" badge shown in the corner of a premium user's avatar.
 * Graphics will be swapped to the provided asset when available.
 * For now renders a styled ★ icon as a placeholder.
 */
const SupporterBadge = ({ size = 24, sx = {} }) => (
  <Tooltip title="Supporter" arrow placement="top">
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
        border: '1.5px solid #fff',
        cursor: 'default',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{ fontSize: size * 0.52, lineHeight: 1, userSelect: 'none' }}
      >
        ★
      </Box>
    </Box>
  </Tooltip>
);

export default SupporterBadge;
